<template>
  <div style="height: 100vh;width: 100vw;">
    <!-- 页头 -->
    <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
    <div style="height: 60px;"></div>
    <div style="display: flex;height: calc(100% - 60px);width: 100%;">
      <!-- 侧边栏 -->
      <side-bar></side-bar>
      <div style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
        <div class="content-box">
          <div class="table-list">
            <!-- <div class="tab">
              <span style="color: #333;">用户信息</span>
              <span style="margin: 0px 10px;">></span>
              <span>用户列表</span>
            </div> -->
            <div class="title-box">
              <!-- 标题 -->
              <div class="title">用户列表</div>
              <!-- 按钮 -->
              <div class="btn-box">
                <!-- <div
                  class="btn"
                  @click="deleteallshow()"
                >批量删除</div> -->
                <!-- <div class="btn">排序</div>
                <div
                  class="btn"
                  @click="exportExcel()"
                >
                  <img
                    class="exportimg"
                    src="../assets/img/export.png"
                  >
                  导出
                </div> -->
              </div>
            </div>

            <!-- 下拉选择框 -->
            <div class="select-box">
              <div class="select">
                <el-input clearable v-model="phone" placeholder="请输入手机号"></el-input>
              </div>
              <div class="select">
                <el-input clearable v-model="name" placeholder="请输入用户名"></el-input>
              </div>
              <div class="select">
                <el-input clearable v-model="company" placeholder="请输入公司名称"></el-input>
              </div>
              <div class="search" @click="handleSearch()">查询</div>
              <div style="margin-left: auto;display: flex;">
                <div class="btn search" @click="addadminBtn()">添加用户</div>
                <div class="btn search" @click="handleSearch()">刷新</div>
              </div>
            </div>
            <div class="listsbox hqsjkdata">
              <div>
                <div class="networkListtitle">
                  <div class="inputcheck">
                    <!-- <div
                      class="titlebox"
                      style="width: 32px;"
                    >
                      <el-checkbox
                        v-model="checkAll"
                        @change="checkall()"
                      ></el-checkbox>
                    </div> -->
                    <div class="username titlebox" style="color: #333;">用户名称</div>
                  </div>
                  <div class="usermobile titlebox">用户手机号</div>
                  <div class="userfirm titlebox">公司名称</div>
                  <div class="useremail titlebox">所在行业</div>
                  <div class="userdate titlebox">所在地区</div>
                  <div class="userdate titlebox">创建时间</div>
                  <!--<div class="networknum titlebox">网络数量</div>
                  <div class="equipmentnum titlebox">设备数量</div> -->
                  <!-- <div class="networkoperate titlebox">
                    <div style="width: 240px; ">操作</div>
                  </div> -->
                </div>
              </div>
              <div>
                <div class="userList" v-for="i in userList" :key="i.id">
                  <div class="inputcheck">
                    <!-- <div style="width: 32px;">
                      <el-checkbox v-model="i.checked"></el-checkbox>
                    </div> -->
                    <div class="username" @click="showUserDetail(i)">{{ i.userName }}</div>
                  </div>
                  <div class="usermobile">{{ i.userMobile }}</div>
                  <div class="userfirm">{{ i.userFirm }}</div>
                  <div class="useremail">{{ i.userIndustry }}</div>
                  <div class="userdate">{{ i.userPlace }}</div>
                  <div class="userdate">{{ i.userDate }}</div>
                  <!--<div class="networknum">{{ i.networkslen }}/{{ i.networknum }}</div>
                  <div class="equipmentnum">{{ i.Memberslen }}/{{ i.equipmentnum }}</div> -->
                  <!-- <div class="networkoperate"> -->
                  <!-- <div class="userkbtn detail" @click="showUserDetail(i)">详情</div> -->
                  <!-- <div class="userkbtn" @click="shownotice(i)">删除</div> -->
                  <!-- <div
                      class="userkbtn"
                      @click="changenumber(i)"
                    >设定网络和设备数量</div> -->
                  <!-- </div> -->

                  <!-- 删除用户 -->
                  <div v-if="deleteUser" class="notice">
                    <div class="overlay"></div>
                    <div class="deleteallbox">
                      <div style="padding: 20px;">提示</div>
                      <div style="text-align: center;padding: 20px 30px">确定删除此用户？删除后用户信息将会被彻底清除！
                      </div>
                      <div style="margin-top: 16px;">
                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="shownotice(i, '删除')" class="addbtn" style="margin-left: 0px;">取消
                          </div>
                          <div @click="userDelete(i.id)" class="addbtn"
                            style="color: white;background-color: #1677ff;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;">
                            确定</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 设定数量 -->
            <div v-if="shownumber" class="notice">
              <div class="overlay"></div>
              <div class="addbox">
                <div class="addtitle">设置数量</div>
                <div class="addtable">
                  <el-form :rules="rules" ref="form" :model="form" label-width="80px">
                    <el-form-item label="网络数量" prop="name">
                      <el-input clearable placeholder="请输入网络数量" v-model="form.networknum"></el-input>
                    </el-form-item>
                    <el-form-item label="设备数量">
                      <el-input clearable placeholder="请输入设备数量" v-model="form.equipmentnum"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="display: flex;justify-content: end;">
                    <div class="addbtn" @click="changenumber()">取消</div>
                    <div class="addbtn" @click="enternumber(i)" style="background-color: #012f55;color: white;">确认
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 删除所有展示 -->
            <div v-if="alldelete">
              <div class="overlay"></div>
              <div class="deleteallbox">
                <div style="padding: 20px;">提示</div>
                <div style="text-align: center;padding: 20px 30px">确定删除所选用户？删除后用户信息将会被彻底清除！</div>
                <div style="margin-top: 16px;">
                  <div style="display: flex;justify-content: flex-end;">
                    <div @click="deleteallcancel()" class="addbtn" style="margin-left: 0px;">取消
                    </div>
                    <div @click="deleteallenter()" class="addbtn"
                      style="color: white;background-color: #012f55;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;">
                      确定</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <!-- 分页 -->
            <!-- <div class="currentpage">
              <button
                class="pagination"
                @click="goToPreviousPage()"
                :disabled="currentPage === 1"
                :class="{ 'pagination-hover': currentPage !== 1 }"
              >上一页</button>
              <span
                v-for="page in pages"
                :key="page"
              >
                <button
                  @click="goToPage(page)"
                  class="pagination2"
                  :class="{ 'pagination-active': page === currentPage }"
                >{{
                                    page }}</button>
              </span>
              <button
                class="pagination"
                @click="goToNextPage()"
                :class="{ 'pagination-hover': currentPage !== totalPages }"
                :disabled="currentPage === totalPages"
              >下一页</button>
              <span style="margin-left:10px;">总数：{{fuserList.length}}</span>
            </div> -->
            <el-pagination @size-change="handleSizeChange" style="float: right;margin-bottom: 10px;"
              @current-change="handleCurrentChange" :current-page="current" :pager-count="5"
              :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
              :total="fuserList">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <custom-drawer :title="userDetail.userName" size="70%" :visible="drawer" @close="handleClose">
      <template v-slot:title>
        <div class="usertitle flex">
          <p>
            {{ userDetail.userName }}
          </p>
          <el-button type="primary" size="medium" link @click="deleteVisible = true">删除</el-button>
        </div>
      </template>
      <div class="account flex">
        <h3>用户详情</h3>
        <p>
          <span>账号类型：</span>
          <span>{{ accountType }}</span>
        </p>
      </div>
      <div class="basic-msg flex">
        <ul class="basic-list">
          <li>
            <p>用户名称：</p>
            <p>{{ userDetail.userName }}</p>
          </li>
          <li>
            <p>联系方式：</p>
            <p>{{ userDetail.userMobile }}</p>
          </li>
          <li>
            <p>所在地区：</p>
            <p>{{ userDetail.userPlace }}</p>
          </li>
        </ul>
        <ul class="basic-list">
          <li>
            <p>公司名称：</p>
            <p>{{ userDetail.userFirm }}</p>
          </li>
          <li>
            <p>注册日期：</p>
            <p>{{ userDetail.userDate }}</p>
          </li>
          <li>
            <p>所属行业：</p>
            <p>{{ userDetail.userIndustry }}</p>
          </li>
        </ul>
        <ul class="basic-list">
          <li>
            <p>用户总数：</p>
            <p>{{ userDetail?.organizationStats?.userCount }}</p>
          </li>
          <li>
            <p>组织总数：</p>
            <p>{{ userDetail?.organizationStats?.organizationCount }}</p>
          </li>
          <li>
            <p>网络总数：</p>
            <p>{{ userDetail?.organizationStats?.networkCount }}</p>
          </li>
        </ul>
        <ul class="basic-list">
          <li>
            <p>网关在线总数：</p>
            <p>{{ userDetail?.organizationStats?.onlineCount }}</p>
          </li>
          <li>
            <p>网关离线总数：</p>
            <p>{{ userDetail?.organizationStats?.offlineCount }}</p>
          </li>
          <li>
            <p>网关待上线总数：</p>
            <p>{{ userDetail?.organizationStats?.inactiveCount }}</p>
          </li>
        </ul>
      </div>
      <custom-tabs v-if="drawer" class="custom-tabs" v-bind:tabsTitle="tabsTitle">
        <template v-slot:first>
          <div class="table">
            <custom-table v-bind:props="props" v-bind:tableData="tableData.records">
              <template #status="{ row }">
                <ul class="state">
                  <li v-show="row.state == '1'">在线</li>
                  <li v-show="row.state == '0'">离线</li>
                  <li v-show="row.state == '-1'">等待初次上线</li>
                </ul>
              </template>
              <template #organize="{ row }">
                <span>{{ currentGatewayId(row.organizationID) }}</span>
              </template>
            </custom-table>
          </div>
          <div class="cpagination flex">
            <custom-pagination :currentPage="current" :pageSize="size" :total="tableData?.total"
              @updateCurrentPage="updateCurrentPage" @updatePageSize="updatePageSize"></custom-pagination>
          </div>
        </template>
        <template v-slot:second>
          <div class="table">
            <custom-table v-bind:props="memberprops" v-bind:tableData="membertableData.records">
              <template #organize="{ row }">
                <span>{{ currentGatewayId(row.userOrganizationID) }}</span>
              </template>
            </custom-table>
          </div>
          <div class="cpagination flex">
            <custom-pagination :currentPage="current2" :pageSize="size2" :total="membertableData?.total"
              @updateCurrentPage="updateCurrentPage2" @updatePageSize="updatePageSize2"></custom-pagination>
          </div>
        </template>
        <template v-slot:third>
          <div class="table">
            <custom-table v-bind:props="resourceprops" v-bind:tableData="resourcetableData">
              <template #theme="{ row }">
                <ul class="state nopay">
                  <li v-show="row.theme == 1">已购买</li>
                  <li v-show="row.theme == 0">未购买</li>
                </ul>
              </template>
            </custom-table>
          </div>
        </template>
      </custom-tabs>
    </custom-drawer>
    <!-- 用户按钮 -->
    <custom-dialog width="600px" title="新增用户" :showCancelConfirm="false" :visible.sync="dialogVisible"
      @update:visible="handleVisible">
      <template>
        <custom-form class="custom-form-top" ref="customFormRef" labelPosition="top" :formItems="formItems"
          :formData="formData" :formRules="formRules" @update:formData="updateFormData" @submit="handleFormSubmit"
          @handleFormClose="handleFormClose"></custom-form>
      </template>
    </custom-dialog>
    <!-- 确认删除 -->
    <custom-dialog width="400px" title="提示" :showCancelConfirm="false" :visible.sync="deleteVisible"
      @update:visible="handleVisible">
      <div style="text-align: center;padding: 0px 0px">确认删除此用户？删除后该用户资源将会彻底删除！</div>
      <div style="margin-top: 36px;">
        <div style="display: flex;justify-content: flex-end;">
          <div @click="deleteVisible = false" class="addbtn" style="margin-left: 0px;">取消
          </div>
          <div @click="handleDrawerSure" class="addbtn"
            style="color: white;background-color: #1677ff;margin-left: 20px;margin-right: 15px;margin-bottom: 0px;">
            确定</div>
        </div>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import excel from '@/libs/excel'
import bcrypt from 'bcryptjs';
import { placeOptions, regionOptions } from '@/libs/constant'
export default {
  data() {
    return {
      selectedUser: null,
      alldelete: false,
      shownumber: false,
      startdate: '',
      enddate: '',
      fuserList: null,
      userList: [],
      // dataList: [],
      search: '',
      phone: '',
      name: '',
      company: '',
      checkAll: '',
      currentPage: 1,
      itemsPerPage: 16,
      drawer: false,
      activeName: "first",
      organizationID: "",
      userDetail: {},
      tableData: [],
      membertableData: [],
      resourcetableData: [],
      affiliatedOrganize: [],
      loading: false,
      deleteUser: false,
      dialogVisible: false,
      deleteVisible: false,
      currentUserId: {},
      tabsTitle: [
        {
          label: "网关详情",
          name: "first",
        },
        {
          label: "成员详情",
          name: "second",
        },
        {
          label: "资源详情",
          name: "third",
        },
      ],
      props: [
        {
          label: "网关名称",
          prop: "gatewayName",
          // slots: "name",
        },
        {
          label: "状态",
          prop: "state",
          slots: "status",
        },
        {
          label: "SN",
          prop: "bindingSN",
          width: "170px"
        },
        {
          label: "网关型号",
          prop: "product",
        },
        {
          label: "固件版本",
          prop: "version",
        },
        {
          label: "所属组织",
          prop: "organizationID",
          slots: "organize",
        },
        {
          label: "安装地址",
          prop: "positioning",
        },
        {
          label: "备注",
          prop: "label",
        },
      ],
      memberprops: [
        {
          label: "成员名称",
          prop: "userName",
          width: "300px"
        },
        {
          label: "联系方式",
          prop: "userMobile",
          width: "300px"
        },
        {
          label: "角色名称",
          prop: "roleName",
        },
        {
          label: "所属组织",
          prop: "userOrganizationID",
          slots: "organize",
        },
      ],
      resourceprops: [
        {
          label: "主题",
          prop: "theme",
          slots: "theme",
          width: "600px"
        },
        {
          label: "用户",
          prop: "user",
        },
      ],
      form: {
        networknum: '',
        equipmentnum: ''
      },
      rules: {
        networknum: [
          { required: true, message: '请输入网络数量', trigger: 'blur' },
          { min: 1, max: 20, trigger: 'blur' }
        ],
        equipmentnum: [
          { required: true, message: '请输入设备数量', trigger: 'blur' },
          { min: 0, max: 20, trigger: 'blur' }
        ],
      },
      formData: {
        phone: "",
        password: "",
        confirmPassword: "",
        firm: "",
        place: "",
        region: "",
      },
      formItems: [
        {
          id: "1",
          type: "input",
          label: '手机号',
          placeholder: "手机号",
          prop: "phone",
          required: true,
        },
        {
          id: "2",
          type: "input",
          label: '密码',
          placeholder: "密码",
          prop: "password",
          required: true,
          isShowPsw: true,
        },
        {
          id: "3",
          type: "input",
          label: '确认密码',
          placeholder: "确认密码",
          prop: "confirmPassword",
          required: true,
          isShowPsw: true,
        },
        {
          id: "5",
          type: "input",
          label: '公司名称',
          placeholder: "公司名称",
          prop: "firm",
          required: true,
        },
        {
          id: "6",
          type: "select",
          label: '所属行业',
          placeholder: "所属行业",
          model: regionOptions,
          propsConfig: { value: "value", label: "label", isLeaf: "leaf" },
          prop: "place",
        },
        {
          id: "7",
          type: "select",
          label: '所属地区',
          placeholder: "所属地区",
          model: placeOptions,
          propsConfig: { value: "value", label: "label", isLeaf: "leaf" },
          prop: "region",
        },
        {
          id: "9",
          type: "cs-btn",
        },
      ],
      formRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: ["change", "blur"] },
          { min: 7, max: 11, message: "手机号格式不正确", trigger: ["change", "blur"] },
          // { validator: validateMobile, trigger: ["change", "blur"] },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["change", "blur"],
          },
          { min: 6, max: 18, message: "密码长度在6-18位", trigger: ["change", "blur"] },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: ["change", "blur"] },
          { validator: this.validateConfirmPsw, trigger: ["change", "blur"] },
        ],
        firm: [{ required: true, message: "请输入公司名称", trigger: ["change", "blur"] }],
      },
      current: 1,
      size: 10,
      current2: 1,
      size2: 10,
    }
  },
  created() {
    this.$js.token();
    //sessionStorage.setItem('tabid', '25');
    sessionStorage.setItem('path', '/Userdata');
    sessionStorage.setItem('netpage', '1');
    this.selectuser()
    this.changeheight()
  },
  computed: {
    displayedBoxes() {
      const startIndex = this.currentPage * this.itemsPerPage - this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      return this.fuserList.slice(startIndex, endIndex)
    },
    totalPages() {
      return Math.ceil(this.fuserList.length / this.itemsPerPage)
    },
    pages() {
      const pages = [1];
      for (let i = 2; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
    accountType() {
      if (this.userDetail.userOrganizationID) {
        return '子账号'
      } else {
        return '主账号'
      }
    }
  },
  methods: {
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.size = val;
      this.selectuser();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.current = val;
      this.selectuser();
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    // 获取页面大小
    changeheight() {
      if (document.documentElement.clientHeight <= 800 && document.documentElement.clientHeight > 750) {
        this.itemsPerPage = 12
      } else if (document.documentElement.clientHeight <= 750 && document.documentElement.clientHeight > 720) {
        this.itemsPerPage = 11
      } else if (document.documentElement.clientHeight < 720) {
        this.itemsPerPage = 7
      }
    },
    // 删除成员
    async userDelete(id) {
      // console.log(this.currentUserId);
      let res = await this.$apiFun.deleteuser({ id: this.currentUserId.id })
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        //this.dialogFormVisible = false;
        this.delid = '';
        this.selectuser();
      }
      //alert(res)
      //location.reload()
    },
    // 展示删除框
    shownotice(item, type) {
      // console.log(item);
      if (type === '删除') {
        this.deleteUser = false
      } else {
        this.deleteUser = true
        this.currentUserId = item
      }
      // if (item.notice) {
      //   item.notice = !item.notice
      // } else {
      //   console.log(item, this.fuserList, 'xthis.fuserList')
      //   // this.fuserList.forEach(item => {
      //   //   item.notice = false
      //   // })
      //   // item.notice = !item.notice
      // }
    },
    //展示改变设备数量
    changenumber(i) {
      this.shownumber = !this.shownumber
      if (i) {
        this.selectedUser = i
        this.form.networknum = i.networknum
        this.form.equipmentnum = i.equipmentnum
      }
    },
    //改变设备数量
    async enternumber() {
      let id = this.selectedUser.id
      let networknum = this.form.networknum
      let equipmentnum = this.form.equipmentnum
      let res = await this.$apiFun.changenumber({ id, networknum, equipmentnum })
      // console.log(res);
      location.reload()
    },
    // 时间开始
    changestartdate() {
      this.fuserList = [];
      let start = this.startdate ? this.startdate.getTime() : 0;
      let end = this.enddate ? this.enddate.getTime() : Infinity;
      this.fuserList = this.userList.filter(item => {
        let itemDate = item.date
        return itemDate >= start && itemDate <= end;
      });

    },
    //批量删除
    deleteallshow() {
      const allFalse = this.fuserList.every(obj => obj.checked === false);
      if (allFalse) {
        alert('请选择需要删除的用户')
      } else {
        this.alldelete = true
      }
    },
    deleteallcancel() {
      this.alldelete = false
    },
    deleteallenter() {
      const startIndex = this.currentPage * this.itemsPerPage - this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      this.fuserList.slice(startIndex, endIndex).forEach(async item => {
        if (item.checked == true) {
          let id = item.nwid
          let res = await this.$apiFun.networksDelete({ id });
          alert(res)
        }
      })
      this.alldelete = false
    },
    // 搜索功能
    async handleSearch() {
      this.userList = [];
      //this.fuserList = 0;
      let id = JSON.parse(sessionStorage.getItem('user')).id
      // this.userList.forEach(item => {
      //   if (item.mobile.includes(this.searchphone)) {
      //     this.fuserList.push(item);
      //   }
      // });
      let res = await this.$apiFun.selectuser({ phone: this.phone, name: this.name, company: this.company });
      this.userList = res.data.records
      this.fuserList = res.data.total
    },
    // 时间戳转换
    time(date) {
      let timestamp = parseInt(date);
      let time = new Date(timestamp);
      // 获取年、月、日
      let year = time.getFullYear();
      let month = ("0" + (time.getMonth() + 1)).slice(-2); // 月份是从0开始的，所以需要加1
      let day = ("0" + time.getDate()).slice(-2);
      // 格式化日期
      let formattedDate = year + "-" + month + "-" + day;
      return formattedDate
    },
    // 全选
    checkall() {
      this.fuserList.forEach(item => item.checked = this.checkAll)
    },
    //导出操作
    exportExcel() {
      let List = []
      this.fuserList.forEach(item => {
        if (item.checked == true) {
          List.push(item)
        }
      })
      if (List.length > 0) {
        const params = {
          title: ['账号', '电话', '邮箱', '注册日期', '网络数量', '设备数量'],
          key: ['name', 'mobile', 'email', 'date', 'networknum', 'equipmentnum'],
          data: List, // 数据源
          autoWidth: true, //autoWidth等于true，那么列的宽度会适应那一列最长的值
          filename: '客户数据'
        }
        excel.exportArrayToExcel(params)
      } else {
        alert('请勾选需要导出的网络')
      }
    },
    //查询用户信息
    async selectuser() {
      let Memberslen = 0
      let networkslen = 0
      let id = JSON.parse(sessionStorage.getItem('user')).id
      let issuper = JSON.parse(sessionStorage.getItem('user')).issuper
      if (issuper == '超级管理员') {
        issuper = 'manager';
      }
      let res = await this.$apiFun.selectuser({ id, issuper, current: this.current, size: this.size, phone: this.phone, name: this.name, company: this.company });
      if (res == false) {
        // console.log(res);
      } else {
        this.userList = res.data.records
        this.userList.forEach(async (item) => {
          let userid = item.id
          //let res = await this.$apiFun.networks({ userid });
          // 获取已使用成员数量
          // let memberPromises = res.map(async (item) => {
          //   let id = item.nwid
          //   let length2 = await this.$apiFun.getnetworksMember({ id });
          //   return Object.keys(length2).length
          // })
          // let memberCounts = await Promise.all(memberPromises)
          // Memberslen = memberCounts.reduce((a, b) => a + b, 0)
          // 等待异步执行结束后再执行
          // networkslen = res.length
          // this.$set(item, 'networkslen', networkslen)
          // this.$set(item, 'Memberslen', Memberslen)
        })
        //生成checked
        this.userList.forEach(item => this.$set(item, 'checked', false))
        // 生成notice
        this.userList.forEach(item => this.$set(item, 'notice', false))
        this.userList.sort((a, b) => {
          return a.date - b.date
        })
        this.fuserList = res.data.total
      }
    },
    // 修改操作
    updata() {
      alert('修改还没做')
    },
    async showUserDetail(row) {
      this.userDetail = row
      // console.log(row, 'ddddddddddddd')
      this.drawer = true
      this.resourcetableData = []
      if (this.userDetail.userOrganizationID) {
        this.organizationID = this.userDetail.userOrganizationID
      } else {
        this.organizationID = this.userDetail.id
      }
      this.gatewayList()
      this.memberList()
      this.resourceList()
      this.getAffiliatedOrganize()
    },
    async gatewayList() {
      let res = await this.$apiFun.userdetailgatewaylist({ organizationID: this.organizationID, current: this.current, size: this.size });
      // console.log(res, 'dfffffffffffffffff');
      this.tableData = res.data
    },
    async memberList() {
      let res = await this.$apiFun.userdetailMemberlist({ organizationID: this.organizationID, current: this.current, size: this.size });
      // console.log(res, 'dfffffffffffffffff');
      this.membertableData = res.data
    },
    async resourceList() {
      let res = await this.$apiFun.userdetailResourcelist({ organizationID: this.organizationID, current: this.current, size: this.size });
      // console.log(res, 'dfffffffffffffffff');
      this.resourcetableData.push(res.data)
    },
    async getAffiliatedOrganize() {
      let res1 = await this.$apiFun.userdetailAffiliatedOrganize({ organizationID: this.organizationID });
      // console.log(res1, 'dfffffffffffffffff');
      this.affiliatedOrganize = res1.data
    },
    currentGatewayId(id) {
      let oId = this.affiliatedOrganize.find(item => item.id === id)
      // console.log(idw, id, 'fffffffffffffff');
      return oId?.organizationName
    },
    updateCurrentPage(value) {
      this.current = value;
      this.gatewayList()
    },
    updatePageSize(value) {
      this.size = value;
      this.gatewayList()
    },
    updateCurrentPage2(value) {
      this.current2 = value;
      this.memberList()
    },
    updatePageSize2(value) {
      this.size2 = value;
      this.memberList()
    },
    handleClose() {
      this.drawer = false
      this.current = 1
      this.size = 10
      this.current2 = 1
      this.size2 = 10
    },
    // 打开用户el-dialog
    addadminBtn() {
      this.dialogVisible = true
      // console.log(this.formData, 'ddddddddddddddddd');
    },
    // 用户dialog关闭
    handleVisible() {
      this.dialogVisible = false
      this.$refs.customFormRef?.resetForm()
    },
    // 修改表单-单项
    updateFormData(data) {
      // console.log(data);
      this.formData = data
    },
    // 用户点击form中的确定
    async handleFormSubmit(data) {
      const salt = await bcrypt.genSalt(10);
      const secretpwd = await bcrypt.hash(data.password, salt);
      const secretconfpwd = await bcrypt.hash(data.confirmPassword, salt);
      const userparams = {
        confirmPassword: secretconfpwd,
        firm: data.firm,
        password: secretpwd,
        phone: data.phone,
        place: data.place,
        region: data.region,
      }
      console.log(secretpwd, secretconfpwd, userparams, 'fffff');
      const res = await this.$apiFun.userdataregister(userparams)
      // console.log(res, 'ddddddddddddddd');
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.dialogVisible = false
        this.$refs.customFormRef?.resetForm()
        this.selectuser()
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    },
    // 点击form表单中的取消 - 用户dialog关闭 
    handleFormClose() {
      this.dialogVisible = false
      this.clearForm()
    },
    clearForm() {
      this.formData.phone = ''
      this.formData.password = ''
      this.formData.confirmPassword = ''
      this.formData.firm = ''
      this.formData.place = ''
      this.formData.region = ''
    },
    // 确认密码
    validateConfirmPsw(rule, value, callback) {
      if (value != this.formData.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    },
    async handleDrawerSure() {
      // console.log(this.userDetail, 'fhhhhhhhhhhhhhhhhh')
      let res = await this.$apiFun.userdelete(this.userDetail.id);
      console.log(res, 'resssssssssssssssssttttttttttttttt')
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.deleteVisible = false
        this.drawer = false
        this.selectuser()
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    }
  }
}
</script>

<style scoped lang="less">
.content-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 1.1%;
  background-color: white;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  width: 0px;
}

.tab {
  font-size: 12px;
  padding-top: 10px;
  height: 38.8px;
  line-height: 38.8px;
}

.title-box {
  margin: 20px 0px 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.title {
  font-size: 14px;
  font-weight: 700;
}

.btn-box {
  margin: -15px 0px 0px 0px;
  display: flex;
}

.addbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 300px;
  z-index: 999;
  background-color: white;
}

.addtitle {
  padding: 25px 0px 0px 15px;
  font-size: 14px;
  font-weight: bold;
}

.addtable {
  margin-top: 40px;
  padding: 0px 80px;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.notice {
  color: #333333;
  z-index: 999;
}

.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.1);
  /* 半透明黑色背景 */
  z-index: 999;
  /* 确保在上层 */
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: white !important;
}

/* .userkbtn:hover {
  color: #70c31d;
  cursor: pointer;
} */

.exportimg {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.select-box {
  display: flex;
}

.select {
  margin: 0px 10px 20px 0px;
}

.search {
  margin: 0px 10px 20px 0px;
  line-height: 32px;
  padding: 0 16px;
  background-color: #1677ff;
  color: white;
  cursor: pointer;
  font-size: 12px;
}

.networkListtitle {
  min-width: 1640px;
  font-size: 13px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding: 0 8px;
  font-weight: bold;
  background-color: #fafafb;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.inputcheck {
  display: flex;
}

.username {
  width: 240px;
  cursor: pointer;
  color: #1677ff;
}

.select-box:deep(.el-input__inner) {
  width: 151px;
  height: 32px;
}

.select-box:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
  width: 150px;
}

.select-box:deep(.el-input__icon) {
  line-height: 32px;
}

.select:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.select:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.btn {
  display: flex;
  align-items: center;
  padding: 0px 16px;
  height: 32px;
  line-height: 32px;
  margin: 0px 10px 0px 0px;
  border: 1px solid #e7e9f1;
  cursor: pointer;
  font-size: 12px;
  color: #fff;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 210px; */
  /* height: 100px; */
  z-index: 999;
  background-color: white !important;
}

.userList {
  min-width: 1640px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  padding: 8px;
  font-size: 12px;
}

.userList:hover {
  background: #fafafb;
}

.usermobile {
  width: 200px;
  flex-shrink: 0;
}

.userfirm {
  width: 240px;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
}

.useremail {
  width: 311px;
  flex-shrink: 0;
}

.userdate {
  width: 275px;
  flex-shrink: 0;
}

// .networknum {
//   width: 9.22%;
//   flex-shrink: 0;
// }

// .equipmentnum {
//   width: 9.22%;
//   flex-shrink: 0;
// }

.networkoperate {
  position: relative;
  width: 100px;
  display: flex;
  // justify-content: space-between;
}

.networkoperate.titlebox {
  padding-right: 8px;
}

.userkbtn {
  color: #f5222d;
  border: none;
  cursor: pointer;
  height: 100%;
  margin-right: 6px;

  &:last-child {
    margin-right: 0;
  }
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #012f55;
}

.inputcheck:deep(.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background: #012f55;
  border-color: #012f55;
}

.select:deep(.el-input__inner) {
  line-height: 32px;
  font-size: 12px;
}

.select:deep(.el-input__inner:hover) {
  border-color: #012f55;
}

.notice:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.notice:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.titlebox {
  padding: 8px 0px;
  background-color: #fafafb;
}

// 弹窗内容样式
.account {
  align-items: center;
  white-space: nowrap;

  p {
    margin-left: 30px;

    span {
      &:nth-child(2) {
        margin-left: 5px;
      }
    }
  }
}

.basic-msg {
  width: 100%;
  min-width: 1021px;
  // flex: 1;
  // height: 100px;
  background-color: #fafafb;
  padding: 15px 20px;
  justify-content: space-between;
}

.basic-list {
  min-width: 250px;
}

.basic-list,
.basic-right-list {
  // min-width: 220px;

  li {
    display: flex;
    height: 30px;
    line-height: 30px;

    p {
      &:nth-child(1) {
        // width: 100px;
        text-align: right;
        flex-shrink: 0;
        font-weight: bold;
      }

      &:nth-child(2) {
        min-width: 170px;
        margin-left: 5px;
        // white-space: nowrap;
      }
    }
  }
}

.custom-tabs {
  margin-top: 15px;
  min-width: 1021px;
}

::v-deep .el-avatar {
  width: 140px;
  height: 200px;
}

.table {
  flex: 1;
  height: 100%;
  position: relative;

  .el-table {
    height: 100%;
    position: absolute;
  }
}

.cpagination {
  width: 100%;
  justify-content: end;
  margin-top: 15px;
}

.nopay {
  li {
    width: 56px;
    white-space: nowrap;
    // padding: 0px 8px;
  }
}

.detail {
  color: #1677ff;
}

.usertitle {
  width: 100%;
  align-items: center;
  justify-content: space-between;

  .el-button {
    padding: 0px;
    background-color: transparent;
    border: none;
    color: #f5222d;
    margin-right: 6px;

    span {
      font-size: 14px;
    }
  }
}

@media screen and (min-width: 1680px) {
  .titlebox {
    padding: 8px 0px;
    border: none;
  }

  .networkListtitle {
    background-color: #fafafb;
    border-top: 1px solid #e7e9f1;
    border-bottom: 1px solid #e7e9f1;
  }
}
</style>